import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { commissionSplitsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type UseUpdateCommissionSplitMutationProps = {
	onSuccess?: (result) => void;
	onError?: (error: ErrorResponse) => void;
};

type UseMutationProps = {
	agentId: string;
	commissionId: string;
	commissionSplitData: { [key: string]: any };
};

const useUpdateCommissionSplitMutation = ({
	onSuccess,
	onError,
}: UseUpdateCommissionSplitMutationProps = {}) => {
	const dispatch = useDispatch();

	return useMutation(
		({ agentId, commissionId, commissionSplitData }: UseMutationProps) => {
			return commissionSplitsService.updateCommissionSplit(
				agentId,
				commissionId,
				commissionSplitData,
			);
		},
		{
			onSuccess(result) {
				dispatch(
					uiActions.showSuccessNotification({
						title: "Commission Split has been successfully updated.",
					}),
				);
				onSuccess?.(result);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
				onError?.(error);
			},
		},
	);
};

export default useUpdateCommissionSplitMutation;
